import React from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'

import { AmountInput, TextInput } from '../../../base'
import { inputProperties } from '../../../types/inputProperties'
import { validators } from '../../../utils/validators'
import InputGroup from '../../../base/InputGroup/InputGroup'
import WidgetSection from '../../../base/Widget/WidgetSection'

export interface PaymentDetailsFormProps {
  accountName: inputProperties
  amount: inputProperties
  form?: UseFormReturn
  accountNumber: inputProperties
  memo: inputProperties
}

const PaymentDetailsForm = (props: PaymentDetailsFormProps) => {
  const defaultForm = props.form || useForm()

  Object.assign(PaymentDetailsForm.defaultProps.amount, props.amount)
  Object.assign(
    PaymentDetailsForm.defaultProps.accountNumber,
    props.accountNumber,
  )
  Object.assign(PaymentDetailsForm.defaultProps.accountName, props.accountName)
  Object.assign(PaymentDetailsForm.defaultProps.memo, props.memo)

  const shouldShowMemo = !props.memo?.disabled
  return (
    <>
      <WidgetSection title='Payment Amount'>
        <AmountInput
          form={defaultForm}
          rules={{
            min: {
              value: 1,
              message: 'Minimum value is 1',
            },
            max: {
              value: 9999999999.99,
              message: 'Maximum value is 99,999,999.99',
            },
            validate: validators.amount,
          }}
          {...PaymentDetailsForm.defaultProps.amount}
        />
      </WidgetSection>
      <WidgetSection title='Payment Details'>
        <InputGroup
          inputRows={[
            [
              <TextInput
                form={defaultForm}
                onChange={props.accountName?.onChange}
                rules={{
                  validate: validators.paymentDetailsAccountName,
                }}
                {...PaymentDetailsForm.defaultProps.accountName}
              />,
            ],
            [
              <TextInput
                form={defaultForm}
                onChange={props.accountNumber?.onChange}
                rules={{
                  validate: validators.paymentDetailsAccountNumber,
                }}
                {...PaymentDetailsForm.defaultProps.accountNumber}
              />,
            ],
            ...(shouldShowMemo
              ? [
                  [
                    <TextInput
                      disabled={props.memo?.disabled}
                      form={defaultForm}
                      {...PaymentDetailsForm.defaultProps.memo}
                    />,
                  ],
                ]
              : []),
          ]}
        />
      </WidgetSection>
    </>
  )
}

PaymentDetailsForm.defaultProps = {
  accountName: {
    label: 'Account Name',
    id: 'accountName',
    name: 'accountName',
    required: true,
  },
  amount: {
    id: 'amount',
    name: 'amount',
    required: true,
  },
  accountNumber: {
    label: 'Account or Invoice Number',
    id: 'accountNumber',
    name: 'accountNumber',
    required: true,
  },
  invoiceUploader: {
    id: 'invoiceUploader',
    dragAndDropLabel: 'Drag & Drop or Click to Browse',
    name: 'invoiceUploader',
    required: false,
  },
  memo: {
    label: 'Memo for Recipient (Optional)',
    id: 'memo',
    name: 'memo',
    required: false,
  },
  disableDocumentUpload: false,
}

export default PaymentDetailsForm
